module.exports = __webpack_public_path__ + "static/CustomBg-a99df0f18cdbf00061c1922b9638f542.png";